import type { Action, ThunkAction, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';

import { authReducer } from '../auth/store/auth.reducer';
import { cartReducer } from '../cart/store/cart.reducer';
import { contentReducer } from '../content/store/content.reducer';
import { elementReducer } from '../elements/store/element.reducer';
import { featureFlagsReducer } from '../feature-flags/store/feature-flags.reducer';
import { membershipListener } from '../membership/store/membership.listeners';
import { membershipReducer } from '../membership/store/membership.reducer';
import { perksListener } from '../perks/store/perks.listeners';
import { perksReducer } from '../perks/store/perks.reducer';
import { musicReducer} from '../music/store/music.reducer';

export function createAppStore() {
  return configureStore({
    reducer: {
      auth: authReducer,
      content: contentReducer,
      membership: membershipReducer,
      element: elementReducer,
      perks: perksReducer,
      cart: cartReducer,
      music: musicReducer,
      featureFlags: featureFlagsReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().prepend(membershipListener.middleware).prepend(perksListener.middleware),
  });
}

export const store = createAppStore();

export type RootState = ReturnType<typeof store.getState>;
// Properly typed dispatch that supports async thunks
export type AppDispatch = ThunkDispatch<RootState, undefined, UnknownAction>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
